<template>
  <div>
    <div class="margin-bottom-40">
      <div class="clearfix">
        <address-autocomplete
          id="autoComplete2"
          v-model="formData.standaloneAddress"
          :validate="'required'"
          name="address"
          label="Standalone address autocomplete wrapper"
          placeholder="Enter Address"
        />
      </div>

      <div class="clearfix margin-top-10">
        <p class="h4 font-size-12">Address form component</p>
        <address-form withLabels class="margin-top-10" :address-changed="onAddressChanged" />
      </div>

      <div class="flex margin-top-20 justify-end">
        <bulletin-button class="margin-right-15" @click="reset()">Clear validations</bulletin-button>
        <bulletin-button variant="primary" @click="submit()">Submit</bulletin-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  provide() {
    return { parentValidator: this.$validator };
  },
  data() {
    return {
      formData: {
        standaloneAddress: "",
      },
      addressObject: {},
    };
  },
  methods: {
    submit: async function () {
      await this.$validator.validate();
    },
    reset: async function () {
      this.$validator.reset();
    },
    onAddressChanged: function (address) {
      this.addressObject = address;
      console.log("this.addressObject", this.addressObject);
    },
  },
};
</script>
